const REQUEST_TEMPLATE_LIST_DASHBOARD = "REQUEST_TEMPLATE_LIST_DASHBOARD";
const RECEIVE_TEMPLATE_LIST_DASHBOARD = "RECEIVE_TEMPLATE_LIST_DASHBOARD";

export const TemplateDashboardTypes = {
  REQUEST_TEMPLATE_LIST_DASHBOARD,
  RECEIVE_TEMPLATE_LIST_DASHBOARD
};
